import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faHexagon } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CSSProperties } from "react"

export type Props = {
  icon: IconProp
  onClick?: () => void
  disabled?: boolean
  color?: 'green' | 'blue' | 'yellow'
  number?: number
}

const buttonSize = { width: '62px', height: '62px' }
const colorMap = {
  green: '#10a983',
  blue: '#6881d4',
  yellow: '#c6ac1f'
}

const numberStyle: CSSProperties = {
  position: 'relative',
  zIndex: 1,
  fontSize: '8pt',
  textAlign: 'center',
  marginTop: '22px'
}

const HeroButton = ({ icon, onClick, disabled, color = "green", number }: Props) => {
  const hexColor = colorMap[color]
  return <div
    className='fa-stack fa-2x'
    onClick={() => !disabled && onClick?.()}
    style={{ ...buttonSize, opacity: disabled ? .9 : 1, cursor: 'pointer' }}
  >
    <FontAwesomeIcon icon={faHexagon} color={hexColor} size="lg" className='fa-stack-1x' style={{ ...buttonSize }} />
    <FontAwesomeIcon icon={icon} className='fa-stack-2x' color='white' style={{ width: '26px', height: '26px', opacity: disabled ? .35 : 1 }} />
    {number !== undefined && <div style={numberStyle}>{number}</div>}
  </div>
}

export default HeroButton
